import React, { FC } from 'react';
import { View } from 'react-native';

import { scale } from '@components/frame';

import ColorWrapper from '@styles/colors';
import { WithColor } from '@styles/colors';

import ClampingTool from '@components/clampingTool/index';
import Loading from '@components/loading';

import { useManageToolsGeneralContent } from '@v2/pages/machines/modules/now/components/Tools/hooks/useManageToolsGeneralContent';
import { TEST_IDS } from '@v2/pages/common/constants/base.constants';

interface ToolsGeneralContentProps extends WithColor {
  maxDetailsWidth?: number;
  loading?: boolean;
  bg?: string;
  refetchTools?: () => void;
}

const ToolsGeneralContent: FC<ToolsGeneralContentProps> = (props) => {
  const { C, loading, refetchTools } = props;

  const {
    selectedItem,
    panelViewMode,
    ncFileName,
    ncFileId,
    maxDetailsWidth,
    containerStyle,
    contentStyle,
  } = useManageToolsGeneralContent({ C, maxDetailsWidth: props.maxDetailsWidth, bg: props.bg });

  return (
    <View style={containerStyle}>
      <View
        style={[
          {
            flex: 1,
            flexDirection: panelViewMode ? 'row' : 'column',
            width: '100%',
          },
          { maxWidth: maxDetailsWidth },
        ]}
      >
        <View
          style={[
            {
              width: '100%',
              flex: 1,
            },
          ]}
        >
          {loading && (
            <View testID={TEST_IDS.clampingTool.loading} style={{ marginTop: scale(40) }}>
              <Loading background={'transparent'} />
            </View>
          )}

          {!loading && (
            <View style={contentStyle}>
              <ClampingTool
                {...{
                  ...props,
                  selectedItem,
                  panelViewMode,
                  largeView: false,
                  route: { params: { ncFile: ncFileName, ncFileId } },
                  refetchTools,
                }}
              />
            </View>
          )}
        </View>
      </View>
    </View>
  );
};

export default ColorWrapper(ToolsGeneralContent);
